import config from '../config/config.json';

interface JsonConfig {
    SENTRY_DSN: string,
    BASE_URL: string,
    API_URL: string,
    GOOGLE_MAPS_API_KEY: string,
    CONTROL_URL: string,
}

const useJsonConfig = (): JsonConfig => {
    return config as JsonConfig;
    // return {
    //     SENTRY_DSN: $config.public.SENTRY_DSN,
    //     BASE_URL: $config.public.BASE_URL,
    //     API_URL: $config.public.API_URL,
    //     GOOGLE_MAPS_API_KEY: $config.public.GOOGLE_MAPS_API_KEY,
    //     CONTROL_URL: $config.public.CONTROL_URL,
    // } as JsonConfig;
}

export { useJsonConfig }
